import { QcUserSchema } from "@/modules/staff/objects/conversation/QcUser";
import { z } from "zod";

export type QcConversationDetailForUser = z.infer<typeof QcConversationDetailForUserSchema>;
export const QcConversationDetailForUserSchema = z.object({
  fix_flg: z.boolean(),
  conversation_name: z.string(),
  role: z.string(),
  p2p_peer: QcUserSchema.nullable(),
  join_status: z.string(),
});
